var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-date-range-picker d-flex flex-wrap align-center" },
    [
      _c("app-date-picker", {
        staticClass: "mr-1",
        attrs: {
          value: _vm.startDate,
          label: _vm.startLabel,
          outlined: _vm.outlined,
          dense: _vm.dense,
          "hide-details": true,
          "input-class": _vm.pickerClass,
          max: _vm.endDate || undefined,
        },
        on: { input: _vm.onStartInput },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "date-sep mx-1" }, [_vm._v("~")]),
      _vm._v(" "),
      _c("app-date-picker", {
        staticClass: "mr-1",
        attrs: {
          value: _vm.endDate,
          label: _vm.endLabel,
          outlined: _vm.outlined,
          dense: _vm.dense,
          "hide-details": true,
          "input-class": _vm.pickerClass,
          min: _vm.startDate || undefined,
        },
        on: { input: _vm.onEndInput },
      }),
      _vm._v(" "),
      _vm.showShortcuts
        ? _vm._l(_vm.shortcuts, function (sc) {
            return _c(
              "v-btn",
              {
                key: sc.type,
                staticClass: "mr-1",
                attrs: {
                  color:
                    sc.type === "reset" ? "grey darken-1" : "grey darken-2",
                  outlined: "",
                  small: "",
                  elevation: "0",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("shortcut", sc.type)
                  },
                },
              },
              [_vm._v(_vm._s(sc.label))]
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }